import { render, staticRenderFns } from "./RowCol.vue?vue&type=template&id=60529387&"
import script from "./RowCol.vue?vue&type=script&lang=js&"
export * from "./RowCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports